import { ImageType } from "entities/common";
import { DELETE, POST } from "utils/http";

const baseUrl = "/api/assets";

export const upload = (assetId: number, files: File[]) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));

  return POST<FormData, ImageType[]>(`${baseUrl}/${assetId}/images`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const remove = (assetId: number, imageId: number) => DELETE(`${baseUrl}/${assetId}/images/${imageId}`);
